module.exports = __webpack_public_path__ + "static/img/graymore_profile_1080x1076.e5fa386.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/graymore_profile_1080x1076.jpg
// module id = zt3a
// module chunks = 0